// extracted by mini-css-extract-plugin
export default {"actionWrapper":"ModalAction_actionWrapper__ypk2h","label":"ModalAction_label__QOXLh","cancelLabel":"ModalAction_cancelLabel__QE2hc"};